// src/routesMapping.js
import AdminRegisterUser from './components/admin/AdminRegisterUser';
import AdminDashboardOverview from './pages/admin/DashboardOverview';
import { Cancellation } from './pages/admin/Cancellation';
import { Completed } from './pages/admin/Completed';
import { CourtDunningProcedure } from './pages/admin/CourtDunningProcedure';
import { Foreclosures } from './pages/admin/Foreclosures';
import { Installmentpayment } from './pages/admin/Installmentpayment ';
import { Resubmissions } from './pages/admin/Resubmissions';
import { Paid } from './pages/admin/Paid';
import { DebtCollection } from './pages/admin/DebtCollection';
import { ClaimsAdmin } from './pages/admin/Claims';
import ClientRegisterUser from './components/client/ClientRegisterUser';
import { Clients } from './pages/admin/Clients';
import ClientDashboardOverview from './pages/client/DashboardOverview';
import { Claims } from './pages/client/Claims';
import Profile from './pages/client/Profile';
import { UploadClaim } from './pages/client/UploadClaim';
import Lexware from './components/client/connect/Lexware';
import ExcelUpload from './components/client/connect/ExcelUpload';
import FastBill from './components/client/connect/FastBill';
import Xentral from './components/client/connect/Xentral';
import Sevdesk from './components/client/connect/Sevdesk';
import SageActive from './components/client/connect/SageActive';
import Signin from "./pages/examples/Signin";
import NotFound from './pages/examples/NotFound';
import ResetPassword from './pages/examples/ResetPassword';
import { RoutesCustom } from "./routes";
import { Completed2 } from './pages/client/Completed';
import { Messages } from './pages/client/Messages';
import { Messages2 } from './pages/admin/Messages';
import MandatePage from './pages/client/MandatePage';
import FeedbackClient from './pages/client/Feedback';
import FeedbackAdmin from './pages/admin/Feedback';
export const RouteComponents = {
    // Public
    [RoutesCustom.Signin.url]: Signin,
    [RoutesCustom.NotFound.url]: NotFound,
    [RoutesCustom.ResetPassword.url]: ResetPassword,
    // Admin
    [RoutesCustom.AdminDashboardOverview.url]: AdminDashboardOverview,
    [RoutesCustom.AdminSignup.url]: AdminRegisterUser,
    [RoutesCustom.ClaimsAdmin.url]: ClaimsAdmin,
    [RoutesCustom.Clients.url]: Clients,
    [RoutesCustom.Cancellation.url]: Cancellation,
    [RoutesCustom.DebtCollection.url]: DebtCollection,
    [RoutesCustom.Completed.url]: Completed,
    [RoutesCustom.Completed2.url]: Completed2,
    [RoutesCustom.CourtDunningProcedure.url]: CourtDunningProcedure,
    [RoutesCustom.Foreclosures.url]: Foreclosures,
    [RoutesCustom.Installmentpayment.url]: Installmentpayment,
    [RoutesCustom.Resubmissions.url]: Resubmissions,
    [RoutesCustom.Paid.url]: Paid,
    [RoutesCustom.Messages2.url]: Messages2,
    [RoutesCustom.FeedbackAdmin.url]: FeedbackAdmin,

    // Client
    [RoutesCustom.ClientDashboardOverview.url]: ClientDashboardOverview,
    [RoutesCustom.ClientSignup.url]: ClientRegisterUser,
    [RoutesCustom.Claims.url]: Claims,
    [RoutesCustom.Mandate.url]: MandatePage,
    [RoutesCustom.Profile.url]: Profile,
    [RoutesCustom.UploadClaim.url]: UploadClaim,
    [RoutesCustom.Messages.url]: Messages,
    [RoutesCustom.Lexware.url]: Lexware,
    [RoutesCustom.ExcelUpload.url]: ExcelUpload,
    [RoutesCustom.FastBill.url]: FastBill,
    [RoutesCustom.Xentral.url]: Xentral,
    [RoutesCustom.Sevdesk.url]: Sevdesk,
    [RoutesCustom.SageActive.url]: SageActive,
    [RoutesCustom.FeedbackClient.url]: FeedbackClient,
    //Special Client

};
